import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import Navbar from "../src/components/Navbar"
import Landing from "./pages/Landing"
import Footer from "../src/components/Footer"
import "@ant-design/v5-patch-for-react-19"
import Login from "./pages/Login"
import SignUp from "./pages/SignUp"
import About from "./pages/About"
import Contact from "./pages/Contact"
import Faq from "./pages/Faq"
import NotFound from "./pages/NotFound"
import Cart from "./pages/Cart"
import Profile from "./pages/Profile"
import { AuthProvider } from "./contexts/authContext"
import ResetPassword from "./pages/ResetPassword"
import LoggedRoute from "./contexts/routeContext/LoggedRoute"
import SellerRoute from "./contexts/routeContext/SellerRoute"
import NonSellerRoute from "./contexts/routeContext/NonSellerRoute"
import AdminRoute from "./contexts/routeContext/AdminRoute"
import ActiveUserRoute from "./contexts/routeContext/ActiveUserRoute"
import ProductsBySeller from "./pages/ProductsBySeller"
import { ModalProvider } from "./contexts/ModalContext/ModalContext"
import AddProduct from "./pages/AddProduct"
import EditProduct from "./pages/EditProduct"
import BulkProducts from "./pages/BulkProducts"
import ProductDetail from "./pages/ProductDetail"
import Categories from "./pages/Categories"
import AdminPageHome from "./pages/AdminPageHome"
import NavOrFootByAdmin from "./contexts/routeContext/NavOrFootByAdmin"
import NotApproved from "./pages/NotApproved"
import AcceptTerms from "./pages/AcceptTerms"
import AIAgent from "./pages/AIAgent"
import QuoteDetails from "./pages/QuoteDetails"
import FloatingAssistantButton from "./components/FloatingAssistantButton"
import MyQuoteRequests from "./pages/MyQuoteRequests"
import IncomingQuoteRequests from "./pages/IncomingQuoteRequests"
import QuoteRequestDetail from "./pages/QuoteRequestDetail"

function App() {
  return (
    <AuthProvider>
      <ModalProvider>
        <Router>
          <div className="App">
            <NavOrFootByAdmin>
              <Navbar />
            </NavOrFootByAdmin>
            <Routes>
              {/* Rutas públicas sin verificación de estado de usuario */}
              <Route path="/signin" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/ai-agent" element={<AIAgent />} />
              <Route path="/notapproved" element={<NotApproved />} />
              <Route
                path="/acceptterms"
                element={
                      <LoggedRoute>
                        <AcceptTerms />
                      </LoggedRoute>
                }
              />
              <Route
                path="/"
                element={
                  <ActiveUserRoute>
                    <NonSellerRoute>
                      <Landing />
                    </NonSellerRoute>
                  </ActiveUserRoute>
                }
              />
              <Route
                path="productos/:searchTerm"
                element={
                  <ActiveUserRoute>
                    <NonSellerRoute>
                      <Landing />
                    </NonSellerRoute>
                  </ActiveUserRoute>
                }
              />
              <Route
                path="/categories"
                element={
                  <ActiveUserRoute>
                    <NonSellerRoute>
                      <Categories />
                    </NonSellerRoute>
                  </ActiveUserRoute>
                }
              />
              <Route
                path="/producto/:productId"
                element={
                  <ActiveUserRoute>
                    <NonSellerRoute>
                      <ProductDetail />
                    </NonSellerRoute>
                  </ActiveUserRoute>
                }
              />
              <Route
                path="/cart"
                element={
                  <ActiveUserRoute>
                    <LoggedRoute>
                      <Cart />
                    </LoggedRoute>
                  </ActiveUserRoute>
                }
              />
              <Route
                path="/quote/:id"
                element={
                  <ActiveUserRoute>
                    <NonSellerRoute>
                      <LoggedRoute>
                        <QuoteDetails />
                      </LoggedRoute>
                    </NonSellerRoute>
                  </ActiveUserRoute>
                }
              />
              {/* Rutas para solicitudes de cotización - Compradores */}
              <Route
                path="/mis-cotizaciones"
                element={
                  <ActiveUserRoute>
                    <NonSellerRoute>
                      <LoggedRoute>
                        <MyQuoteRequests />
                      </LoggedRoute>
                    </NonSellerRoute>
                  </ActiveUserRoute>
                }
              />
              <Route
                path="/mis-cotizaciones/:quoteRequestId"
                element={
                  <ActiveUserRoute>
                    <NonSellerRoute>
                      <LoggedRoute>
                        <QuoteRequestDetail />
                      </LoggedRoute>
                    </NonSellerRoute>
                  </ActiveUserRoute>
                }
              />
              <Route
                path="/profile"
                element={
                    <LoggedRoute>
                      <Profile />
                    </LoggedRoute>
                }
              />
              <Route
                path="/myproducts"
                element={
                  <ActiveUserRoute>
                    <SellerRoute>
                      <ProductsBySeller />
                    </SellerRoute>
                  </ActiveUserRoute>
                }
              />
              <Route
                path="/add-product"
                element={
                  <ActiveUserRoute>
                    <SellerRoute>
                      <AddProduct />
                    </SellerRoute>
                  </ActiveUserRoute>
                }
              />
              <Route
                path="/bulk-products"
                element={
                  <ActiveUserRoute>
                    <SellerRoute>
                      <BulkProducts />
                    </SellerRoute>
                  </ActiveUserRoute>
                }
              />
              <Route
                path="/edit-product/:productId"
                element={
                  <ActiveUserRoute>
                    <SellerRoute>
                      <EditProduct />
                    </SellerRoute>
                  </ActiveUserRoute>
                }
              />
              {/* Rutas para solicitudes de cotización - Proveedores */}
              <Route
                path="/solicitudes-cotizacion"
                element={
                  <ActiveUserRoute>
                    <SellerRoute>
                      <IncomingQuoteRequests />
                    </SellerRoute>
                  </ActiveUserRoute>
                }
              />
              {/* Rutas solo para administradores */}
              <Route
                path="/admin/*"
                element={
                  <ActiveUserRoute>
                    <AdminRoute>
                      <AdminPageHome />
                    </AdminRoute>
                  </ActiveUserRoute>
                }
              />
              <Route
                path="*"
                element={
                  <ActiveUserRoute>
                    <NotFound />
                  </ActiveUserRoute>
                }
              />
                <Route
                path="/notapproved"
                element={
                    <NotApproved />
                }
              />
            </Routes>
            <FloatingAssistantButton />
            <NavOrFootByAdmin>
              <Footer />
            </NavOrFootByAdmin>
          </div>
        </Router>
      </ModalProvider>
    </AuthProvider>
  )
}

export default App
